import { Invoice } from "./legalEntityPracticeV3Invoices.state.model";

export class LoadInvoices {
  static readonly type = '[Invoice] LoadInvoices';
  constructor(public legalEntityNumber: string, public memberId: string) {}
}

export class LoadInvoicesSuccess {
  static readonly type = '[Invoice] LoadInvoicesSuccess';
  constructor(public legalEntityInvoices: Invoice[], public legalEntityNumber: string) {}
}

export class LoadInvoicesFailure {
  static readonly type = '[Invoice] LoadInvoicesFailure';
  constructor(public error: any, public legalEntityNumber: string) {}
}

export class SeeLegalEntityInvoice {
  static readonly type = '[Invoice] SeeLegalEntityInvoice';
  constructor(public invoiceId: string, 
        public billNumber: string, 
        public memberId: string,
        public legalEntityNumber: string) {}
}

export class SeeLegalEntityInvoiceSuccess {
  static readonly type = '[Invoice] SeeLegalEntityInvoiceSuccess';
  constructor(public data: any, public legalEntityNumber: string) {}
}

export class SeeLegalEntityInvoiceFailure {
  static readonly type = '[Invoice] SeeLegalEntityInvoiceFailure';
  constructor(public error: any, public legalEntityNumber: string) {
  }
}

//load memberId
export class LoadMemberId {
  static readonly type = '[Invoice] LoadMemberId';
  constructor(public permitNumber: string) { }
}
export class LoadMemberIdSuccess {
  static readonly type = '[Invoice] LoadMemberIdSuccess';
  constructor(public data: string) { }
}
export class LoadMemberIdFailure {
  static readonly type = '[Invoice] LoadMemberIdFailure';
  constructor(public error: any) { }
}